export default __webpack_public_path__ + "static/media/SndLowerJTurn.5147c860.mp3";